__turbopack_context__.v({
  "ansimSolution": "AnsimSolution-module-scss-module__Yof6uG__ansimSolution",
  "backgroundImage": "AnsimSolution-module-scss-module__Yof6uG__backgroundImage",
  "br": "AnsimSolution-module-scss-module__Yof6uG__br",
  "content": "AnsimSolution-module-scss-module__Yof6uG__content",
  "highlightText": "AnsimSolution-module-scss-module__Yof6uG__highlightText",
  "icon": "AnsimSolution-module-scss-module__Yof6uG__icon",
  "inner": "AnsimSolution-module-scss-module__Yof6uG__inner",
  "navy": "AnsimSolution-module-scss-module__Yof6uG__navy",
  "red": "AnsimSolution-module-scss-module__Yof6uG__red",
  "solutionCard": "AnsimSolution-module-scss-module__Yof6uG__solutionCard",
  "solutionCards": "AnsimSolution-module-scss-module__Yof6uG__solutionCards",
  "textContent": "AnsimSolution-module-scss-module__Yof6uG__textContent",
  "title": "AnsimSolution-module-scss-module__Yof6uG__title",
  "wrap": "AnsimSolution-module-scss-module__Yof6uG__wrap",
  "yellow": "AnsimSolution-module-scss-module__Yof6uG__yellow",
});
